import styled from 'styled-components';

export const Button = styled.button`
  display: block;
  width: 300px;
  height: 45px;
  font-size: 20px;
  color: #fff;
  background: #3a3a3a;
  border: none;
  border-radius: 5px;
  margin: 10px;
  background: ${(props) => (props.disabled ? '#999999' : '#3a3a3a')};
  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`;

export const SaveButton = Button.extend`
  background: ${(props) => (props.disabled ? '#999999' : '#5da834')};
  &:hover {
    background: ${(props) => (props.disabled ? '#999999' : '#1B8100')};
  }
`;

export const ClearButton = Button.extend`
  background: ${(props) => (props.disabled ? '#999999' : '#db2828')};
  &:hover {
    background: ${(props) => (props.disabled ? '#999999' : '#d01919')};
  }
`;

export const GenerateMenuButton = Button.extend`
  background: ${(props) => (props.disabled ? '#999999' : '#3a3a3a')};
  &:hover {
    background: ${(props) => (props.disabled ? '#999999' : '#505f79')};
  }
`;

export const GeneratePDFButton = Button.extend`
  background: ${(props) => (props.disabled ? '#999999' : '#157aac')};
  &:hover {
    background: ${(props) => (props.disabled ? '#999999' : '#17ade3')};
  }
`;

export const SaveToTemplateButton = Button.extend`
  background: #157aac;
  &:hover {
    background: #17ade3;
  }
`;

export const PublishComplexButton = Button.extend`
  background: #785cb4;
  &:hover {
    background: #62487c;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/ActionsButtons.jsx